import { GoogleLogin } from '@react-oauth/google'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '../context/AuthContext.jsx'
import logo from '../assets/logo.png'

export default function LoginPage() {
  const { login, user } = useAuth()
  const navigate = useNavigate()
  const [error, setError] = useState(null)

  if (user) {
    navigate('/', { replace: true })
    return null
  }

  async function handleSuccess(credentialResponse) {
    setError(null)
    try {
      await login(credentialResponse.credential)
    } catch (err) {
      const detail = err?.body?.detail || err?.message || 'Login failed.'
      setError(detail)
    }
  }

  function handleError() {
    setError('Google sign-in was cancelled or failed.')
  }

  return (
    <div className="loginPage">
      <div className="loginCard">
        <img src={logo} alt="RCA Admin" className="loginLogo" />
        <h1 className="loginTitle">Appquantum Platform</h1>
        <p className="loginSubtitle">Sign in with your Google account to continue</p>

        <div className="loginGoogleButton">
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleError}
            theme="outline"
            size="large"
            width="300"
          />
        </div>

        {error ? <p className="loginError">{error}</p> : null}
      </div>
    </div>
  )
}
